function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="17" height="17" xmlns="http://www.w3.org/2000/svg" {...props}><g transform="translate(1)" fill="none" fillRule="evenodd"><circle stroke="#278C7E" strokeWidth="1.364" fill="#FFF" fillRule="nonzero" cx="7.5" cy="8.5" r="7.5" /><text fontFamily="ProductSans-Bold, Product Sans" fontSize="13.636" fontWeight="bold" fill="#278C7E"><tspan x="4" y="13">?</tspan></text></g></svg>;
});